export enum PageAdvertisementTypes {
    BANKING_INTEGRATION,
    PAYABLES,
}
